export enum SideBarMenuActionTypes {
    API_RESPONSE_SUCCESS = '@@sidebarMenu/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@sidebarMenu/API_RESPONSE_ERROR',

    GET_SIDE_BAR_MENU = '@@sidebarMenu/GET_SIDE_BAR_MENU',
    RESET = '@@sidebarMenu/RESET',
    RESET_SUCCESS = '@@sidebarMenu/RESET_SUCCESS',
    RESET_ERROR = '@@sidebarMenu/RESET_ERROR',
}
